import request from '@/utils/request'

let EquipApi = {

  /*回访列表*/
  list(data) {
    return request._post('/shop/plus.equip.equip.Index/index', data);
},
/*添加回访*/
add(data) {
    return request._post('/shop/plus.equip.equip.Index/add', data);
},
/*修改回访*/
edit(data) {
    return request._post('/shop/plus.equip.equip.Index/edit', data);
},
/*删除回访*/
del(data) {
    return request._post('/shop/plus.equip.equip.Index/del', data);
},
/*回访详情*/
detail(data) {
  return request._post('/shop/plus.equip.equip.Index/detail', data);
},
//获取
getDetail(data) {
  return request._post('/shop/plus.equip.equip.Index/getDetail', data);
},
//获取设备收入
log(data){
  return request._post('/shop/plus.equip.equip.Index/log', data);
},
//获取套餐
package(data){
  return request._post('/shop/plus.equip.equip.Index/package', data);
},
//获取设备所属
belong(data){
  return request._post('/shop/plus.equip.equip.Index/belong', data);
},
//设备套餐详情
detail_package(data) {
  return request._post('/shop/plus.equip.equip.Index/detail_package', data);
},//添加设备套餐
add_package(data) {
  return request._post('/shop/plus.equip.equip.Index/addpackage', data);
},
//修改设备套餐
edit_package(data) {
  return request._post('/shop/plus.equip.equip.Index/editpackage', data);
},
//删除设备套餐
del_package(data) {
  return request._post('/shop/plus.equip.equip.Index/delpackage', data);
},

saveSetting(data, errorback) {
  return request._post('/shop/plus.equip.Setting/getSetting', data, errorback);
},
getSetting(data, errorback) {
  return request._get('/shop/plus.equip.Setting/getSetting', data, errorback);
},

setBelongStatus(data){
  return request._post('/shop/plus.equip.equip.Index/setBelongStatus', data);
},
setStatus(data){
  return request._post('/shop/plus.equip.equip.Index/setStatus', data);
},
setPackageStatus(data){
  return request._post('/shop/plus.equip.equip.Index/setPackageStatus', data);
},
//绑定招商中心/服务商
bindFs(data){
  return request._post('/shop/plus.equip.equip.Index/bindFs', data);
},
//绑定记录详情
ebdetail(data){
  return request._post('/shop/plus.equip.equip.Index/ebdetail', data);
},
edit_belong(data){
  return request._post('/shop/plus.equip.equip.Index/editBelong', data);
},
//解绑设备
canelBindEquip(data){
  return request._post('/shop/plus.equip.equip.Index/canelBindEquip', data);
},
getFileUserById(data){
  return request._post('/shop/plus.equip.equip.Index/getFileUserById', data);
},
getServiceUserById(data){
  return request._post('/shop/plus.equip.equip.Index/getServiceUserById', data);
},
getEquipBySelf(data){
  return request._post('/shop/plus.equip.equip.Index/getEquipBySelf', data);
},
//获取绑定的人员
getLog(data){
  return request._post('/shop/plus.equip.equip.Index/getLog', data);
},
editLog(data){
  return request._post('/shop/plus.equip.equip.Index/editLog', data);
},
getLogReferee(data){
  return request._post('/shop/plus.equip.equip.Index/getLogReferee', data);
},
}
export default EquipApi;



// WEBPACK FOOTER //
// ./src/api/equip.js